module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_açaí.a5e6f6dd.png";